import { memo } from "react"
import { Link } from "@tanstack/react-router"

import { cn } from "@productlane/lib/src/cn"
import { LucideIcon } from "@productlane/ui/src/components/lucide-icon"

// The article a recommendation changes, as an inline mention; a live article
// opens in the editor, a new one has nowhere to go yet.
export const ArticleMention = memo(
	({
		title,
		icon,
		articleId,
	}: {
		title: string
		icon: string
		articleId: string | null
	}) => {
		const body = (
			<>
				<LucideIcon
					icon={icon}
					className="mr-1 inline-block size-[1em] align-[-0.15em] text-secondary"
					style={{ strokeWidth: 1.75 }}
				/>
				{title}
			</>
		)
		// Linear's inline mention: the sentence's own size, wrapping with it,
		// each wrapped line keeping the chip's fill and padding.
		const className =
			"rounded-[5px] bg-gray-150 px-1 py-px text-primary [box-decoration-break:clone] [-webkit-box-decoration-break:clone] dark:bg-gray-800"
		return articleId ? (
			<Link
				to="/edit-docs/$id"
				params={{ id: articleId }}
				data-testid="agent-idea-article-mention"
				className={cn(className, "hover:bg-gray-200 dark:hover:bg-gray-700")}
			>
				{body}
			</Link>
		) : (
			<span data-testid="agent-idea-article-mention" className={className}>
				{body}
			</span>
		)
	},
)
